<template>
<el-dialog
    v-drag
    :title="title"
    :visible.sync="dialogVisible"
    width="1200px"
    :show-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
    v-loading="loading"
  >

  <div>
    <div class="serviceList">
        <div class="serviceList-title">请选择邮箱供应商</div>
        <div class="serviceList-section">
            <div @click="active(item)" class="serviceList-item" :class="item.isActived?'actived':''" v-for="item in emailServiceList" :key="item.id">
                <img :src="item.logoPath" :alt="item.serviceName">
                <div class="icon">
                    <i class="el-icon-success"></i>
                </div>
            </div>
        </div>
    </div>
     <el-form ref="form" class="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item prop="email" label="账户">
            <el-input v-model="form.email" style="width:520px" @blur="blur">
                <template slot="append" v-if="Object.keys(currentService).length > 0 && currentService.emailSuffix">{{currentService.emailSuffix}}</template>
            </el-input>
        </el-form-item>
        <el-form-item prop="passWord" label="密码">
            <el-input v-model="form.passWord" style="width:520px" show-password></el-input>
        </el-form-item>
    </el-form>
  </div>
    <span slot="footer" class="footers">
        <div class="cancel flex_c_c" @click="cancel">取 消</div>
        <div class="ok flex_c_c" @click="ok('form')">确 定</div>
    </span>
</el-dialog>
</template>

<script>

import { getEmailServiceList,addorUpdateAccount } from '@/api/email'
export default {
    props:{
        dialogVisible:{
            type:Boolean,
            default:false
        },
        title:{
            type:String,
            default:'添加邮箱'
        }
    },
    data(){
        return {
            emailServiceList:[],
            currentService:{},
            loading:false,
            form: {
                email: '',
                passWord: ''
            },
            rules: {
                email: [{ required: true, message: '请输入账户', trigger: 'blur' }],
                passWord: [{ required: true, message: '请输入密码/授权码', trigger: 'blur' }]
            },
        };
    },
    watch:{
        async dialogVisible(val){
            if(val){
                this.loading=true;
                await getEmailServiceList().then((res)=>{
                    this.loading=false;
                    if (res.success) {
                        this.emailServiceList = res.data.map(item => ({
                            ...item,
                            isActived: false
                        }))
                    } else {
                        this.$message.error(res.errorMessage)
                    }
                })
            }
        }
    },
    methods:{
        cancel(){
            this.$emit('cancel')
        },
        ok(formName){
            this.$refs[formName].validate(async(valid) => {
                if (valid) {
                    if(Object.keys(this.currentService).length==0){
                        this.$message.error('请选择邮件供应商');
                        return;
                    }

                    if((this.form.email.indexOf('@')==-1 || this.form.email.indexOf('.')==-1) && this.currentService.emailSuffix ==''){
                        this.$message.error('请填写您的邮箱后缀');
                        return;
                    }

                    var email = this.form.email;
                    if(email.indexOf('@')==-1)
                        email = email+=this.currentService.emailSuffix;
                    else if(this.currentService.emailSuffix !='')
                        email = email.split('@')[0]+this.currentService.emailSuffix;

                    var input = {
                        email:email,
                        passWord:this.form.passWord,
                        serviceId:this.currentService.id
                    };
                    await addorUpdateAccount(input).then(res=>{
                        if (res.success) {
                            this.$emit('cancel')
                        } else {
                            this.$message.error(res.errorMessage)
                        }
                    })
                }
            })
        },
       active(item) {
            this.emailServiceList.forEach(i => {
                this.$set(i, 'isActived', false)
            })
            this.$set(item, 'isActived', true);
            this.currentService = item;

            this.blur();
        },
        blur(){
            if(Object.keys(this.currentService).length>0 && this.form.email!='' && this.currentService.emailSuffix !='' && this.form.email.indexOf('@')!=-1)
                this.form.email = this.form.email.split('@')[0];
        },
    }
}
</script>

<style  lang="less"  scoped>
.serviceList-section {
  position: relative; 
  margin-top: 10px;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 10px 10px;
  transition: all 0.2s ease;
  


  .serviceList-item {
    background: white;
    flex: 0 0 150px;
    padding: 5px 8px;
    border-radius: 10px;
    margin-right: 20px;
    cursor: pointer;
    box-shadow: #e2e2e2 0px 0px 2px 2px;
    border:2px transparent solid;
    img {
      width: 100%;
      height: 60px;
      object-fit: contain;
    }

    .icon{
        display: none;
    }
  }
}

/* 滚动条样式 */
.serviceList-section::-webkit-scrollbar {
  height: 6px;
}

.serviceList-section::-webkit-scrollbar-track {
  background-color: transparent;
}

.serviceList-section::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 3px;
  transition: background-color 0.2s ease;
}

.serviceList-section:hover::-webkit-scrollbar-thumb {
  background-color: #cfcfcf;
  cursor: pointer;
}
.serviceList-item.actived{
    border:2px solid #2395f3;
    position: relative;
    overflow: hidden;
}
.serviceList-item.actived .icon{
    display: block;
    position: absolute;
    right: -10px;
    top: 0px;
    border-radius:0 0 0 12px;
    width: 30px;
    height: 20px;
    background: #2395f3;
    z-index: 1;
    color: white;
}
.serviceList-item.actived .icon i{
    margin-left: 4px;
}

.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #EEEEEE;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 16px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background:  rgb(18,88,188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}

.form{
    margin-top: 50px;
}
</style>